<template>
  <div class="terminal">
    <div class="terminal__main">
      <center><h1 class="header1" > Waiting for connection</h1></center>
       <adx-loading-secondary slot="loading" />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/Loading/Secondary'
import { apiV2 } from '@/api/urls'
import api from '@/api'
import config from '@/lib/config'
export default {
  name: 'adx-',
  components: {
  'adx-loading-secondary': LoadingSpinner
  },
  props: {

  },
  data() {
    return {
    messageTimeout: null,
    tunnelTimeout: null,
    port: 0,
    deviceId : 0,
    isMaster: true,
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.deviceId = this.$route.query.id
    this.isMaster = this.$route.query.isMaster
    this.createMessage()
    this.tunnelReady()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    createMessage(){
      (async()=>{
        const data = {
          device_id: this.deviceId,
          is_master : this.isMaster,
          message: 'open_tunnel' 
        }
        const response = await api.post(apiV2.createMessage, data, { needToken: true })
        if (response.status == 201){
          clearTimeout(this.messageTimeout)
        }
        else{
          this.messageTimeout= setTimeout(this.createMessage,5000)
        }
      })();
    },
    tunnelReady(){
      (async()=>{
        let param = {
          'device_id': this.deviceId,
          'is_master': this.isMaster
        }
        const response = await api.get(apiV2.getPortTunnel, { needToken: true, params: param })
        if (response.status == 200){
          clearTimeout(this.tunnelTimeout)
          this.port = response.data.port
          window.location.assign(`${config.sshrDomain}:${this.port}`)
        }
        else{
          this.tunnelTimeout= setTimeout(this.tunnelReady, 2000)
        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';


</style>
